import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { Spinner } from 'reactstrap';

//Logo
import LogoSistema from "../../../assets/img/img/logo.png";

//Components
import Loading from "../../../components/Loading";

//Services
import { showMessage } from "../../../services/message";
import { api_GET } from "../../../services/api_service";

export default function RelatorioIA() {
   const [dadosRelatorio, setDadosRelatorio] = useState([]);
   const [loading, setLoading] = useState(false);

   const queryString = require('query-string');

   async function loadDadosRelatorio() {
      try {
         const query_string = queryString.parse(window.location.search);

         const mes = query_string.mes;
         const ano = query_string.ano;
         const hash_usuario = query_string.hash_usuario;
         const hash_contratada = query_string.hash_contratada;
         const tenantId = query_string.tenantId;

         setLoading(true);
         const { data } = await api_GET(`RelatorioIA?mes=${mes}&ano=${ano}&hash_contratada=${hash_contratada}&hash_usuario=${hash_usuario}`, `${tenantId}`);
         setDadosRelatorio(data);
      } catch (error) {
         showMessage("Aviso", error.message, 'error', null);
      } finally {
         setLoading(false);
      }
   }

   useEffect(() => {
      loadDadosRelatorio();
   }, []);

   return (
      <div className="bg-white" style={{ height: '100vh' }}>
         {loading && <Loading />}
         <div className="container-fluid " style={{ background: "#FFF", height: "100%" }}>
            <div className="d-flex justify-content-between align-items-center p-3">
               <img src={LogoSistema} alt="logo do sistema" height={50} />
               <button
                  className="btn btn-info"
                  id="btnImprimir"
                  onClick={() => {
                     if (!loading) window.print();
                  }}
               >
                  {loading && <Spinner size="sm" color="primary" />} &nbsp; Imprimir &nbsp;
               </button>
            </div>
            <div className="text-center">
               <h1>Relatório de IA</h1>
            </div>
            {!loading &&
               <>
                  <div className="row">
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Mês/Ano: </strong>{dadosRelatorio?.mesAno ?? 0}<span></span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Contratada: </strong>{dadosRelatorio?.contratada ?? 0} <span></span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Serviços:</strong> <span>Demandantes</span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Excluir:</strong> <span>Bueiros</span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Procedente por Status:</strong> <span>Procede</span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Responsividade Execução:</strong> <span>Agendado e Sim</span>
                        </div>
                     </div>
                  </div>

                  <div className="row my-3">
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Memória de cálculo</strong>
                        </div>
                     </div>
                     <div className="col-md-6">
                        <div className="details">
                           <strong>Total dos serviços demandantes</strong>
                        </div>
                     </div>
                  </div>

                  <div className="row my-3">
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Total de serviços dentro do prazo: </strong> <span>{dadosRelatorio?.totalServicosDentroPrazo ?? 0}</span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Total de serviços dentro e fora do prazo: </strong>  <span>{dadosRelatorio?.totalDentroEForaPrazo ?? 0}</span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Valor do cálculo:</strong> <span>{(dadosRelatorio?.valorCalculado ?? 0).toFixed(2)}</span>
                        </div>
                     </div>
                     <div className="col-md-4">
                        <div className="details">
                           <strong>Faixa de Pontos (resultado):</strong> <span>{dadosRelatorio?.resultado ?? 0}</span>
                        </div>
                     </div>
                  </div>

                  <div className="mx-3 w-100">
                     <div className="row my-2">
                        <h2>DETALHAMENTO IA</h2>
                     </div>
                     <div className="row w-100">
                        <table className="table table-bordered table-striped text-center">
                           <thead>
                              <tr>
                                 <th className="text-center">Lote</th>
                                 <th className="text-center">Fora do Prazo</th>
                                 <th className="text-center">Dentro do Prazo</th>
                                 <th className="text-center">Total</th>
                                 <th className="text-center">IA</th>
                                 <th className="text-center">Pontos</th>
                              </tr>
                           </thead>
                           <tbody>
                              {dadosRelatorio && dadosRelatorio?.detalheIA?.length > 0 ? (
                                 dadosRelatorio.detalheIA.map((row, index) => (
                                    <tr key={index} style={row.isTotal ? { fontWeight: 'bold', backgroundColor: '#f0f0f0' } : {}}>
                                       <td className="text-center">{row.lote || ''}</td>
                                       <td className="text-center">{row.foraDoPrazo || 0}</td>
                                       <td className="text-center">{row.dentroDoPrazo || 0}</td>
                                       <td className="text-center">{row.total || 0}</td>
                                       <td className="text-center">{row.isTotal ? (row.ia || 0).toFixed(2) : ''}</td>
                                       <td className="text-center">{row.isTotal ? (row.pontos || 0) : ''}</td>
                                    </tr>
                                 ))
                              ) : (
                                 <tr>
                                    <td colSpan="6" className="text-center">
                                       Nenhum dado encontrado
                                    </td>
                                 </tr>
                              )}
                           </tbody>
                        </table>
                     </div>
                  </div>

                  <div className="mx-3 w-100">
                     <div className="row my-2">
                        <h2 >LISTA DE SACs</h2>
                     </div>
                     <div className="row w-100">
                        <table className="table table-bordered table-striped text-center">
                           <thead>
                              <tr>
                                 <th className="text-center">Número do SAC</th>
                                 <th className="text-center">Data/Hora Registro</th>
                              </tr>
                           </thead>
                           <tbody>
                              {dadosRelatorio && dadosRelatorio?.saCs?.length > 0 ? (
                                 dadosRelatorio.saCs.map((sac, index) => (
                                    <tr key={index}>
                                       <td className="text-center">{sac.numeroSAC}</td>
                                       <td className="text-center">
                                          {!!sac.dataHora ? moment(sac.dataHora).format('DD/MM/YYYY HH:mm:ss') : ""}
                                       </td>
                                    </tr>
                                 ))
                              ) : (
                                 <tr>
                                    <td colSpan="2" className="text-center">
                                       Nenhum SAC encontrado
                                    </td>
                                 </tr>
                              )}
                           </tbody>
                        </table>
                     </div>
                  </div>
               </>
            }
         </div>
      </div>
   );
}